import React, {Component} from 'react'
import {Card, CardBody} from "reactstrap"
import classNames from "classnames"
import ReactPaginate from "react-paginate"
import ListItemMarkErrorTable from './table/ListItemMarkErrorTable'
import ListItemMarkErrorFilters from './filters/ListItemMarkErrorFilters'
import moment from 'moment'
import downloadFileFromData from '../../helpers/downloadFileFromData'
import { exportItemsMarkError, getItemsMarkError } from '../../../services/api/apiItemsMarkError'

class ListItemMarkErrorPage extends Component {
    state = {
        items: [],
        loading: false,
        page: 1,
        total: 0,
        limit: 50,
        error: '',
        filters: {
            barcode: '',
            sku: [],
            typeError: '',
            detailError: '',
            printer: '',
            checker: '',
        }
    }

    componentDidMount() {
        this._getReGenLabels()
        // PubSub.subscribe('LIST_RE_GENERATE', this._getReGenLabels)
    }

    _parseOrderNumber = (string) => {
        const regex = /(#)([0-9]{6,}_[0-9]+)/
        const parsed = string.match(regex)
        
        if (parsed !== null && parsed.length >= 3) {
            return parsed[2]
        } else {
            return string
        }
    }

    _getReGenLabels = async () => { 
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {filters, page, limit} = this.state
            const barcodeParse = this._parseOrderNumber(filters.barcode)

            const error_reason = {
                error_type: filters.typeError,
                error_detail: filters.detailError

            }

            const payload = {
                barcode: barcodeParse,
                sku: filters.sku,
                printer: filters.printer,
                checker: filters.checker,
                error_reason: error_reason,
                page,
                limit
            }

            if(filters.created){
                const review_date = {
                    date_from: filters.created ? filters.created.from : '',
                    date_to: filters.created ? filters.created.to : ''
                }

                payload.review_date = review_date
            }
            
            const {data: respons} = await getItemsMarkError(payload)
            const {success} = respons
    
            if (!success) {
                const {message} = respons

                return this.setState({
                    error: message,
                    loading: false,
                    items: [],
                    total: 0
                })

            }

            const {result} = respons
            const {stores, total} = result

            this.setState({
                items: stores,
                total,
                loading: false,
                error: '',
            })
        } catch (e) {
            this.setState({
                error: e.message,
                loading: false
            })
        }
    }

    _handleChangeLimit = (e) => {
        const {name, value} = e.target

        this.setState({
            [name]: value,
            page: 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _handlePageClick = (page) => {
        const newPage = page.selected

        this.setState({
            page: parseInt(newPage) + 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _handleChangeFilters = (filters) => {
        this.setState({
            filters: {
                ...filters,
            },
            page: 1
        }, () => {
            this._getReGenLabels()
        })
    }

    _handleExportBatch = async() => {
        this.setState({
            loading: true,
            error: ''
        })

        try {
            const {filters, page, limit} = this.state
            const barcodeParse = this._parseOrderNumber(filters.barcode)

            const error_reason = {
                error_type: filters.typeError,
                error_detail: filters.detailError

            }

            const payload = {
                barcode: barcodeParse,
                sku: filters.sku,
                printer: filters.printer,
                checker: filters.checker,
                error_reason: error_reason,
                page,
                limit
            }

            if(filters.created){
                const review_date = {
                    date_from: filters.created ? filters.created.from : '',
                    date_to: filters.created ? filters.created.to : ''
                }

                payload.review_date = review_date
            }

            const {data: response} = await exportItemsMarkError(payload)
            const { success, error } = response

            if (!success) {
                this.setState({
                    error: error,
                    loading: false
                })
            }

            if (response) {
                downloadFileFromData(response, { filename: `items-mark-error-${moment().format('YYYY-MM-DD-HH-mm-ss')}.csv` })
            }

            this.setState({
                loading: false,
            })

        } catch (error) {
            this.setState({
                error: error.message,
                loading: false
            })
        }
    }

    render() {
        const {items, filters, loading, error, total, limit, page} = this.state
       
        const pages = Math.ceil(total / limit)

        return (
            <div className="ReGenerateLabelsPage">
                <Card>
                    <div className="CardHeader card-header header-elements-inline">
                        <div className="header-elements d-flex justify-content-between align-items-center w-100">
                            <h1 className='card-title'>Thống kê item lỗi QC</h1>
                            <div className="actions">
                                <div className="d-flex">
                                    <button
                                        className='btn btn-primary mb-2 mx-1'
                                        style={{ background: '#4A80F7' }}
                                        onClick={this._handleExportBatch}
                                    >
                                        Export
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <CardBody>
                        <ListItemMarkErrorFilters filters={filters} onChangeFilters={this._handleChangeFilters}/>
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <div>{error && <div className="text-danger">{error}</div>}</div>
                            <div className='d-flex align-items-center'>
                                {/* <div className='d-flex align-items-center mr-3'>
                                    <div>Hiển thị</div>
                                    <Input type='select' value={limit} name='limit' onChange={this._handleChangeLimit}
                                           className='ml-1 mr-1 w-auto'>
                                        {
                                            LIMIT.map(item => {
                                                return <option key={item.value} value={item.value}>{item.name}</option>
                                            })
                                        }
                                    </Input>
                                </div> */}
                                <div>
                                    Tổng số <strong>{total}</strong> items
                                </div>
                            </div>
                        </div>

                        <ListItemMarkErrorTable
                            items={items}
                            loading={loading}
                            refreshList={this._getReGenLabels}
                        />

                        {
                            items.length > 0 &&
                            <div className="mt-3 float-right">
                                <ReactPaginate
                                    forcePage={page - 1}
                                    previousLabel='Previous'
                                    previousClassName='page-item previous'
                                    previousLinkClassName='page-link'
                                    nextLabel='Next'
                                    nextClassName='page-item next'
                                    nextLinkClassName='page-link'
                                    breakLabel='...'
                                    breakClassName='break-me'
                                    pageCount={pages}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this._handlePageClick}
                                    containerClassName={classNames('pagination', {loading})}
                                    pageClassName='page-item'
                                    pageLinkClassName='page-link'
                                    activeClassName='active'/>
                            </div>
                        }
                    </CardBody>
                </Card>
            </div>
        )
    }
}

export default ListItemMarkErrorPage